export default {
  booking_confirmation_title: 'Rezervācijas apstiprinājums',
  booking_confirmation_body: 'Paldies par rezervāciju. Lūdzu, skatiet apstiprinājuma informāciju zemāk.',
  location: 'Atrašanās vieta',
  pickup_location: 'Saņemšanas vieta',
  dropoff_location: 'Nodošanas vieta',
  vehicle: 'Transportlīdzeklis',
  pickup_and_dropoff: 'Savākšana un nodošana (vietējais laiks)',
  distance_allowance: 'Attālums piemaksa',
  view_voucher: 'Skatīt kuponu',
  view_more_bookings: 'Skatīt vairāk rezervāciju',
  identity_verification_body: 'Pirms transportlīdzekļa savākšanas mums būs jāpārbauda jūsu identitāte',
  identity_verification_title: 'Pārbaudīt identitāti',
  search_again: 'Meklēt vēlreiz',
  aircon: 'gaisa kondicionieris',
  refrigeration: 'Atdzesēts',
  not_available: 'Drive &amp; Go pašlaik ir pieejama tikai cilvēkiem ar personu apliecinošiem un autovadītāja apliecības dokumentiem no {profiles}, bet mēs nepārtraukti pievienojam jaunas valstis.',
  check_if_included: 'Pārbaudiet, vai jūsu valsts ir iekļauta.',
  included_in_booking: 'Iekļauts šajā rezervācijā',
  cdw_with_excess: 'CDW ar pārpalikumu',
  theft_protection: 'Aizsardzība pret zādzībām',
  risk_reduction: 'Riska samazināšana',
  free_extras: 'Ar šo rezervāciju jums ir tiesības uz divām bezmaksas ekstrām<br />.',
  total_cost: 'Īres kopējās izmaksas',
  continue: 'Turpināt',
  luggage_large_short_label: 'L',
  luggage_medium_short_label: 'V',
  luggage_small_short_label: 'M',
  luggage_large_long_label: 'liels',
  luggage_medium_long_label: 'vidējs',
  luggage_small_long_label: 'mazs',
  fuel_unspecified_label: 'nav norādīts',
  transmission_manual_label: 'Manuālā',
  transmission_automatic_label: 'Automātiskā',
  make_a_booking: 'Veikt rezervāciju',
  pickup_date: 'Savākšanas datums',
  dropoff_date: 'Nodošanas datums',
  driver_age: 'Vadītājs starp 30 - 65',
  enter_driver_age: 'Lūdzu, ievadiet autovadītāja vecumu',
  promo_code: 'Promo kods',
  search: 'Meklēt',
  dropoff_date_cannot_be_before_pickup_date: 'Nodošanas datums nedrīkst būt pirms savākšanas datuma',
  pickup_date_cannot_be_in_the_past: 'Savākšanas datums nevar būt jau pagājis',
  pickup_time_cannot_be_in_the_past: 'Savākšanas laiks nevar būt jau pagājis',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'Nodošanas laiks nedrīkst būt pirms savākšanas laika tajā pašā dienā',
  vehicle_filters: 'Transportlīdzekļu filtri',
  reset: 'Atiestatīt',
  transmission: 'Transmisija',
  all: 'Viss',
  manual: 'Manuālā',
  auto: 'Automātiskā',
  passengers: 'Pasažieri',
  vehicle_type: 'Transportlīdzekļa tips',
  filter: 'Filtrs',
  vehicle_search: 'Transportlīdzekļa meklēšana',
  edit: 'Rediģēt',
  no_results: 'Neviens rezultāts neatbilst jūsu filtrēšanas kritērijiem.',
  small_cars: 'Maza izmēra automašīnas',
  medium_cars: 'Vidēja izmēra automašīnas',
  large_cars: 'Liela izmēra automašīnas',
  estate_cars: 'Universālmašīnas',
  suvs: 'SUV',
  mpvs: 'MPV',
  vans: 'Busi',
  camper_vans: 'Kemperu furgoni',
  premium: 'Piemaksa',
  unspecified: 'nav norādīts',
  large: 'liels',
  medium: 'vidējs',
  small: 'mazs',
  automatic: 'automātisks',
  you_have_been_refunded: 'Jums ir atmaksāts.',
  please_customer_service: 'Lai veiktu rezervāciju, lūdzu, sazinieties ar mūsu klientu apkalpošanas dienestu.',
  contact_customer_service: 'Sazināties ar klientu apkalpošanas dienestu',
  booking_failed: 'Šoreiz jūsu rezervāciju nevarēja apstrādāt.',
  summary: 'Kopsavilkums',
  reforestation_and_protection: 'Atbalstīt mežu atjaunošanu un lietus mežu aizsardzību visā Kostarikā',
  cost_of_rental: 'Īres izmaksas',
  to_pay_now: 'Samaksāt tagad',
  pay_on_arrival: 'Samaksāt ierodoties',
  greenheart_donation: 'Green Heart ziedojumi',
  tc_agreement: 'Esmu izlasījis un sapratis {0}.',
  tc: 'Noteikumus un nosacījumus',
  receive_offers: 'Es vēlētos saņemt īpašos piedāvājumus pa e-pastu.',
  donate: 'Jā, es vēlētos ziedot {amount}',
  pay_now: 'Maksāt {amount} tagad',
  driver_details: 'Vadītāja informācija',
  complete_driver_details: 'Lūdzu, aizpildiet autovadītāja informāciju.',
  are_you_the_driver: 'Vai jūs esat vadītājs?',
  have_an_account: 'Vai jums jau ir konts?',
  login: 'Pieslēgties',
  or: 'vai',
  first_name: 'Autovadītāja vārds',
  last_name: 'Autovadītāja uzvārds',
  email: 'E-pasta adrese',
  phone_number: 'Mobilā tālruņa numurs',
  unable_to_save_driver_information: 'Nevar saglabāt autovadītāja informāciju. Lūdzu mēģiniet vēlreiz.',
  pay_on_arrival: 'Samaksāt ierodoties',
  pay_online_now: 'Maksājiet tiešsaistē tūlīt',
  day: 'Diena',
  choose_location: 'Izvēlieties vietu',
  pickup_location: 'Savākšanas vieta',
  dropoff_location: 'Nodošanas vieta',
  location_not_found: 'Diemžēl mēs nevarējām atrast jūsu pieprasīto atrašanās vietu.',
  add: 'Pievienot',
  remove: 'Noņemt',
  free_extra: 'Bezmaksas ekstra',
  free: 'BEZMAKSAS!',
  fast_track_notice: 'Uz šo pakalpojumu attiecas dokumentu izcelsmes ierobežojumi. Tas ir pieejams tikai cilvēkiem ar dokumentiem no',
  complete_booking: 'Pabeigt rezervāciju',
  choose_card: 'Lūdzu, izvēlieties karti vai pievienojiet jaunu.',
  add_billing_details: 'Lūdzu, pievienojiet norēķinu informāciju.',
  card_number: 'Kartes numurs',
  card_holder_name: 'Kartes īpašnieka vārds',
  card_exp: 'MM / GG',
  card_cvc: 'CVC',
  save_card: 'Saglabāt karti?',
  amount_charged: 'No jūsu kartes tiks novilkta naudas summa',
  payment_confirmation: 'Apstiprināt rezervāciju un maksāt',
  payment_methods: 'Pieejamās maksāšanas metodes',
  use_saved_card: 'x izmantot saglabāto karti',
  use_different_card: '+ izmantot citu karti',
  book_now: 'Rezervēt tagad',
  minimum_age: 'Vienīgi {age}',
  excess_liability: 'Papildus saistības',
  security_deposit: 'Drošības nauda',
  fuel_policy: 'Degvielas politika',
  like_for_like: 'Patīk pret patīk',
  full_to_full: 'Pilns pret pilnu',
  miles_per_rental: '{mileage} bezmaksas jūdzes par rezervācijas reizi',
  km_per_rental: '{mileage} bezmaksas kilometri par rezervācijas reizi',
  unlimited: 'Neierobežots',
  unlimited_mileage: 'Neierobežots jūdžu skaits',
  unlimited_mileage_km: 'Neierobežots km skaits',
  non_amendable: 'Nav maināms',
  non_refundable: 'Neatmaksājams',
  free_cancellation_until: 'Bezmaksas atcelšana līdz',
  cancellation_in_line_with: 'Atcelšana saskaņā ar',
  tcs: 'Noteikumi&amp;',
  free_extras_on_collection: 'Divas bezmaksas ekstras savācot transportlīdzekli',
  glass_and_tyres_covered: 'Stikls un riepas nosegtas',
  number_of_passengers: 'Pasažieru skaits',
  number_of_bags: 'Somu skaits',
  fuel_type: 'Degvielas tips',
  co2: 'CO2',
  aircon: 'Gaisa konc.',
  book_type: 'Rezervēt {type}',
  processing: 'Apstrāde',
  actual_price: 'Faktiskā cena',
  tooltip: 'Cena USD{currencyCode} ir aptuvena, pamatojoties uz valūtas kursu, cena USD{currency} ir saistoša.',
  deposit: 'Depozīts',
  pay_online: 'Maksājiet tiešsaistē tūlīt',
  pay_online_without_extras: 'Īres cena',
  extras_on_arrival: 'Papildus labumi pēc ierašanās',
  insurance_on_arrival: 'Riska samazināšana - maksājiet ierodoties',
  insurance_online: 'Riska samazināšana - maksājiet tūlīt',
  extras_online: 'Papildus labumi maksā tagad',
  green_heart_donation: 'Green Heart ziedojumi',
  aircon_lower: 'gaisa kondicionieris',
  why_use_drive_and_go: 'Kādēļ izmantot Drive & Go?',
  straight_to_car: 'Tieši uz automašīnu',
  no_queues: 'Nav rindu',
  self_checkout: 'Patstāvīga izčekošana',
  cant_lose_key: 'Nevar pazaudēt atslēgu',
  online_id_check: 'Tiešsaistes ID pārbaude',
  phone_as_key: 'Tālrunis kā atslēga',
  premiumplus_benefits_includes: 'Iekļautas arī Plus+ priekšrocības',
  book_drive_go: 'Rezervēt Drive & Go',
  duration: 'Ilgums',
  to_pay_on_arrival: 'Samaksāt ierodoties',
  return_date: 'Atgriešanas datums',
  additional_options: 'Papildu opcijas',
  booking_details: 'Rezervācijas detaļas',
  price_for_x_days: 'Cena par {qty_of_days} dienu | Cena par {qty_of_days} dienām',
  cancelled: 'Atcelts',
  upcoming: 'Drīzumā',
  active: 'Aktīvs',
  my_profile: null,
  drive_and_go: {
    drive_and_go: 'Drive & Go',
    available_countries: 'Drive &amp; Go pašlaik ir pieejama tikai cilvēkiem ar personu apliecinošiem un autovadītāja apliecības dokumentiem no šīm valstīm:',
    drive_and_go_today: 'Rezervē Drive & Go jau šodien!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Kādēļ izmantot Drive & Go?',
    straight_to_car: 'Tieši uz automašīnu',
    no_queues: 'Nav rindu',
    self_checkout: 'Patstāvīga izčekošana',
    cannot_lose_the_key: 'Nevar pazaudēt atslēgu',
    online_id_check: 'Tiešsaistes ID pārbaude',
    phone_as_a_key: 'Tālrunis kā atslēga',
    premium_plus_benefits_also_included: 'Iekļautas arī Plus+ priekšrocības',
    book_drive_and_go: 'Rezervēt Drive & Go'
  },
  my_bookings: "My bookings",
  no_bookings: "No bookings",
  no_bookings_to_display: 'Nav rezervāciju.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Odometrs saņemto',
  fuel_at_collection: 'Degviela saņemot',
  start_check_in: 'Sākt reģistrēšanos',
  start_collection: 'Sākt saņemšanu',
  recent_bookings: 'Nesenā rezervācijas aktiviāte',
  damage: {
    updated_damage_report_submitted: 'Ir iesniegts atjaunināts bojājumu ziņojums. Ja nepieciešams, sazināsies mūsu klientu apkalpošanas komandas locekli.',
    add_additional_damage: 'Pievienojiet papildu bojājumus',
    you_may_report_additional_damage_up_to: 'Par papildu bojājumiem jūs varat ziņot 24 stundu laikā pēc transportlīdzekļa pārbaudes',
    specify_damage: 'Raksturojiet bojājumu',
    please_choose_the_area_and_type_of_damage: 'Lūdzu, izvēlieties apgabalu un bojājuma tipu',
    type_of_damage: 'Bojājuma tips',
    is_this_more_than_5_cm: 'Vai tas ir lielāks par 5cm?',
    please_take_or_select_a_photo: 'Lūdzu, uzņemiet vai izvēlieties fotogrāfiju',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Lūdzu, uzņemiet fotogrāfiju, kurā bojājums ir skaidri redzams',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Ja nepieciešams, varat pievienot vēl vienu fotogrāfiju; izvēlieties ikonu, lai pievienotu vēl vienu fotogrāfiju',
    save_image: 'Saglabāt attēlu',
    save_images: 'Saglabāt attēlus',
    damage_saved_successfully: 'Bojājums saglabāts veiksmīgi',
    add_photo: 'Pievienot fotogrāfiju'
  },
  checkout: {
    start_collection: 'Sākt saņemšanu',
    collect_vehicle: 'Saņemt transportlīdzekli',
    we_will_let_you_know_the_details: 'Mēs paziņosim jums atrašanās vietu un detaļas, lai jūs varētu atrast izīrēto transportlīdzekli.',
    inspect: 'Pārbaude',
    we_will_ask_for_four_photos_from_each_corner: 'Mēs jūs lūgsim uzņemt četras fotogrāfijas no katra transportlīdzekļa stūra, kurās būtu redzami jaunie bojājumi, kas līdz šim nebija norādīti.',
    fuel_and_milage: 'Degviela un nobraukums',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Nomas sākumā ir jāpārbauda odometra un degvielas līmeņa rādījumi.',
    sign: 'Parakstīšanās',
    sign_the_rental_agreement: 'Parakstiet nomas līgumu.',
    away_you_go: 'Varat braukt',
    you_are_free_to_take_to_the_road: 'Varat doties, kur vien sirds kāro!',
    collect_your_vehicle: 'Saņemt savu transportlīdzekli',
    get_directions: 'Rādīt instrukcijas',
    hide_directions: 'Slēpt instrukcijas',
    local_time: 'vietējais laiks',
    tel: 'Tālr.',
    getting_to_the_location: 'Nokļūšana līdz atrašanās vietai',
    get_vehicle_details: 'Saņemt informāciju par transportlīdzekli',
    view_map: 'Rādīt karti',
    unlock_vehicle_and_continue: 'Atslēdziet transportlīdzekli un turpiniet',
    unable_to_connect_to_vehicle: 'Neizdevās savienoties ar transportlīdzekli',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'Mums neizdevās savienoties ar transportlīdzekli — lūdzu, pārbaudiet, ka atrodaties pie pareizā transportlīdzekļa un mēģiniet vēlreiz.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'Mums neizdevās atrast transportlīdzekļa rezervāciju. Lūdzu, pamēģiniet vēlreiz vēlāk.',
    odometer_and_fuel: 'Odometrs un degviela',
    odometer: 'Odometrs',
    please_confirm_the_odometer_and_fuel_readings: 'Lūdzu, pārbaudiet odometra un degvielas līmeņa rādījumus.',
    the_odometer_field_is_required: 'Odometra rādījums ir obligāts,',
    and_must_be_greater_than_the_checkout_odometer: 'un tam jābūt lielākam par izčekošanās odometra rādījumu',
    confirm: 'Apstiprināt',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Lūdzu, uzņemiet fotogrāfijas no visiem transportlīdzekļa stūriem',
    pre_existing_damage: 'Iepriekšējs bojājums',
    no_pre_existing_damage: 'Nav iepriekšēja bojājuma',
    new_damage: 'Jauns bojājums',
    add_additional_damage: 'pievienot papildu bojājumus',
    no_new_damage_to_report: 'Nav jaunu bojājumu, par ko ziņot',
    checkout_complete: 'Izčekošanās pabeigta',
    start_rental: 'Uzsākt nomu',
    congratulations_name_it_is_time_to_take_to_the_road: 'Apsveicam, {customer_name}, laiks doties ceļā!',
    we_are_unable_to_complete_your_vehicle_checkout: 'Mums neizdevās pabeigt jūsu transportlīdzekļa izčekošanu.',
    please_do_the_following: 'Lūdzu, izpildiet sekojošos soļus',
    remove_all_belonging_and_lock_the_vehicle: 'Izņemiet visas savas mantas un aizslēdziet transportlīdzekli.',
    lock_vehicle: 'Aizslēdziet transportlīdzekli',
    once_you_have_contacted_customer_services: 'Kad esat sazinājies ar klientu apkalpošanas dienestu',
    vehicle_location: 'Transportlīdzekļa atrašanās vieta',
    collect_your: 'Saņemiet savu',
    from: 'No',
    key_in_glove_box: 'jūsu atslēga atrodas cimdu kastē',

    keyholder: {
      not_detected: 'Atslēga turētājā nav atrasta',
      not_detected_please_try_again: 'Lūdzu, ievietojiet atslēgu turētājā un mēģiniet vēlreiz.',

      not_installed: 'Atslēgas turētājs nav instalēts',
      not_installed_please_contact_customer_service: 'Atslēgas turētājs nav instalēts, lūdzu, sazinieties ar klientu apkalpošanas dienestu.',
    },
    keyring: {
      look_up_failed: 'Atslēgu uz atslēgu meklēšana neizdevās',
      look_up_failed_please_contact_customer_service: 'Atslēgu atslēga meklēt, lūdzu, sazinieties ar klientu apkalpošanas centru.',
    },
    key: {
      invalid: 'Atslēga nav derīga',
      invalid_please_contact_customer_service: 'Jūsu atslēga nav derīga. Lūdzu, sazinieties ar klientu apkalpošanas dienestu.',

      expired: 'Atslēgas derīguma termiņš ir beidzies',
      expired__please_contact_customer_service: 'Jūsu atslēgas termiņš ir beidzies. Lūdzu, sazinieties ar klientu apkalpošanas dienestu.',
    }
  },
  checkin: {
    tell_us_where_you_have_parked: 'Paziņojiet mums, kur esat noparkojis transportlīdzekli.',
    fuel_and_milage: 'Degviela un nobraukums',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Nomas beigās jums jāpārbauda odometra un degvielas līmeņa rādījums.',
    inspect: 'Pārbaude',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Mēs jūs lūgsim uzņemt četras fotogrāfijas no katra transportlīdzekļa stūra, kurās būtu redzami jaunie bojājumi, kas radušies nomas laikā.',
    lock: 'Aizslēgšana',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Pārbaudiet, vai iekšā nav palikušas jūsu mantas, un tad aizslēdziet transportlīdzekli.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Lūdzu, paziņojiet mums, kur esat noparkojis transportlīdzekli',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Kad transportlīdzeklis tiks aizslēgts, to vairs nebūs iespējams atslēgt.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, lūdzu, pārbaudiet, vai esat atstājis mantas, aizslēdziet transportlīdzekli un, ja nepieciešams, atgrieziet fizisko atslēgu atslēgas turētājam.',
    lock_vehicle: 'Aizslēdziet transportlīdzekli',
    complete_check_in: 'Pabeigt iečekošanos',
    inspection: 'Pārbaude',
    complete_vehicle_check_in: 'Pabeigt transportlīdzekļa iečekošanu',
    we_are_unable_to_complete_your_vehicle_check_in: 'Mums neizdevās pabeigt jūsu transportlīdzekļa iečekošanu.',
    please_contact_customer_services: 'Lūdzu, sazinieties ar klientu atbalsta dienestu',
    once_you_have_contacted_customer_services: 'Kad esat sazinājies ar klientu apkalpošanas dienestu'
  },
  rental_agreement: {
    rental_agreement: 'Nomas līgums',
    agreement_between: 'Līgums starp',
    and: 'un',
    sign_rental_agreement: 'Parakstiet nomas līgumu',
    i_have_read_and_understood_the_terms_and_conditions: 'Esmu lasījis un sapratis Noteikumi un pieņemu transportlīdzekļa stāvokli'
  },
  full_insurance_no_deposit: 'Pilna apdrošināšana un nav nepieciešama iemaksa',
  excess: '{amount} pārsniegums',
  deposit: '{amount} depozīts',
  included_daily_distance: '{distance} {unit} dienā',
  miles: 'jūdzes',
  kilometers: 'kilometri',
  collection_details_title: 'Informācija par kolekciju',
  collection_details_not_found: 'Šai vietai nav definēta kolekcijas informācija',
  free_cancellation: 'Bezmaksas anulēšana',
  no_deposit: 'Nr noguldījumu',
  benefit_from: 'Gūt labumu no',
  for_only_per_day: 'Tikai {price} dienā',
  upgrade_mee: 'UpgradeMee'
}


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/lv/bookings.js